import React from "react";
import {REST_GLIDER_URL} from "../common/constants";
import ExpandableROList from "../common/ExpandableROList";
import {GliderRO} from "./GliderRO";

const GliderListROBase = ExpandableROList(GliderRO, REST_GLIDER_URL, "glider",
    "Seznam kluzáků", (a,b) => (a.name.localeCompare(b.name)));

/** Neaktivní kluzáky se ve výběru nezobrazují; vlastní filterFce se zkombinuje s tímto pravidlem. */
const GliderListRO = (props) => {
    const { filterFce, ...rest } = props;
    const mergedFilter = filterFce
        ? (g) => g.active !== false && filterFce(g)
        : (g) => g.active !== false;
    return <GliderListROBase {...rest} filterFce={mergedFilter} />;
};

export default GliderListRO;